import React from 'react';
import { Account } from '../types/account';
import { useCurrentAccount } from './use-current-account';

export const useIsCurrentAccount = () => {
  const currentAccount = useCurrentAccount();
  return React.useCallback((acc: {id: string} | Account) => acc.id === currentAccount?.id, [currentAccount])
}